// extracted by mini-css-extract-plugin
module.exports = {"guoxue_box":"guoxue_box-1GC1TSkM"};